import '../assets/NcAppContent-aWiDWWeq.css';
import p from "../Components/NcButton.mjs";
import { r, y as c, a as u } from "./_l10n-BaNxGGXy.mjs";
import "../Directives/Tooltip.mjs";
import { emit as a } from "@nextcloud/event-bus";
import { A as h } from "./ArrowRight-C3BxTDjF.mjs";
import { useIsMobile as l } from "../Composables/useIsMobile.mjs";
import { n as o } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
import { VTooltip as f } from "floating-vue";
import { getBuilder as d } from "@nextcloud/browser-storage";
import { useSwipe as g } from "@vueuse/core";
import { Pane as m, Splitpanes as _ } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
r(c);
const z = {
  name: "NcAppDetailsToggle",
  directives: {
    tooltip: f
  },
  components: {
    NcButton: p,
    ArrowRight: h
  },
  setup() {
    return {
      isMobile: l()
    };
  },
  computed: {
    title() {
      return u("Go back to the list");
    }
  },
  watch: {
    isMobile: {
      immediate: !0,
      handler() {
        this.toggleAppNavigationButton(this.isMobile);
      }
    }
  },
  beforeDestroy() {
    this.isMobile && this.toggleAppNavigationButton(!1);
  },
  methods: {
    toggleAppNavigationButton(e = !0) {
      const t = document.querySelector(".app-navigation .app-navigation-toggle");
      t && (t.style.display = e ? "none" : null, e === !0 && a("toggle-navigation", { open: !1 }));
    }
  }
};
var S = function() {
  var t = this, i = t._self._c;
  return i("NcButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: t.title, expression: "title" }], staticClass: "app-details-toggle", class: { "app-details-toggle--mobile": t.isMobile }, attrs: { type: "tertiary", "aria-label": t.title }, scopedSlots: t._u([{ key: "icon", fn: function() {
    return [i("ArrowRight", { attrs: { size: 20 } })];
  }, proxy: !0 }]) });
}, v = [], w = /* @__PURE__ */ o(
  z,
  S,
  v,
  !1,
  null,
  "7e250fb8",
  null,
  null
);
const y = w.exports, n = d("nextcloud").persist().build(), b = {
  name: "NcAppContent",
  components: {
    NcAppDetailsToggle: y,
    Pane: m,
    Splitpanes: _
  },
  props: {
    /**
     * Allows to disable the control by swipe of the app navigation open state
     */
    allowSwipeNavigation: {
      type: Boolean,
      default: !0
    },
    /**
     * Allows you to set the default width of the resizable list in % on vertical-split
     * Allows you to set the default height of the resizable list in % on horizontal-split
     * Must be between listMinWidth and listMaxWidth
     */
    listSize: {
      type: Number,
      default: 20
    },
    /**
     * Allows you to set the minimum width of the list column in % on vertical-split
     * Allows you to set the minimum height of the list column in % on horizontal-split
     */
    listMinWidth: {
      type: Number,
      default: 15
    },
    /**
     * Allows you to set the maximum width of the list column in % on vertical-split
     * Allows you to set the maximum height of the list column in % on horizontal-split
     */
    listMaxWidth: {
      type: Number,
      default: 40
    },
    /**
     * Specify the config key for the pane config sizes
     * Default is the global var appName if you use the webpack-vue-config
     */
    paneConfigKey: {
      type: String,
      default: ""
    },
    /**
     * When in mobile view, only the list or the details are shown
     * If you provide a list, you need to provide a variable
     * that will be set to true by the user when an element of
     * the list gets selected. The details will then show a back
     * arrow to return to the list that will update this prop to false.
     */
    showDetails: {
      type: Boolean,
      default: !0
    },
    /**
     * Specify the `<h1>` page heading
     */
    pageHeading: {
      type: String,
      default: null
    },
    /**
     * Content layout used when there is a list together with content:
     * - `vertical-split` - a 2-column layout with list and default content separated vertically
     * - `no-split` - a single column layout; List is shown when `showDetails` is `false`, otherwise the default slot content is shown with a back button to return to the list.
     * - 'horizontal-split' - a 2-column layout with list and default content separated horizontally
     * On mobile screen `no-split` layout is forced.
     */
    layout: {
      type: String,
      default: "vertical-split",
      validator(e) {
        return ["no-split", "vertical-split", "horizontal-split"].includes(e);
      }
    }
  },
  emits: [
    "update:showDetails",
    "resize:list"
  ],
  setup() {
    return {
      isMobile: l()
    };
  },
  data() {
    return {
      contentHeight: 0,
      hasList: !1,
      hasContent: !1,
      swiping: {},
      listPaneSize: this.restorePaneConfig()
    };
  },
  computed: {
    paneConfigID() {
      if (this.paneConfigKey !== "")
        return "pane-list-size-".concat(this.paneConfigKey);
      try {
        return "pane-list-size-".concat(appName);
      } catch {
        return console.info("[INFO] AppContent:", "falling back to global nextcloud pane config"), "pane-list-size-nextcloud";
      }
    },
    detailsPaneSize() {
      return this.listPaneSize ? 100 - this.listPaneSize : this.paneDefaults.details.size;
    },
    paneDefaults() {
      return {
        list: {
          size: this.listSize,
          min: this.listMinWidth,
          max: this.listMaxWidth
        },
        // set the inverse values of the details column
        // based on the provided (or default) values of the list column
        details: {
          size: 100 - this.listSize,
          min: 100 - this.listMaxWidth,
          max: 100 - this.listMinWidth
        }
      };
    }
  },
  updated() {
    this.checkSlots();
  },
  mounted() {
    this.allowSwipeNavigation && (this.swiping = g(this.$el, {
      onSwipeEnd: this.handleSwipe
    })), this.checkSlots(), this.restorePaneConfig();
  },
  methods: {
    /**
     * handle the swipe event
     *
     * @param {TouchEvent} e The touch event
     * @param {import('@vueuse/core').SwipeDirection} direction The swipe direction of the event
     */
    handleSwipe(e, t) {
      Math.abs(this.swiping.lengthX) > 70 && (this.swiping.coordsStart.x < 300 / 2 && t === "right" ? a("toggle-navigation", {
        open: !0
      }) : this.swiping.coordsStart.x < 300 * 1.5 && t === "left" && a("toggle-navigation", {
        open: !1
      }));
    },
    handlePaneResize(e) {
      const t = parseInt(e[0].size, 10);
      n.setItem(this.paneConfigID, JSON.stringify(t)), this.listPaneSize = t, this.$emit("resize:list", { size: t }), console.debug("AppContent pane config", t);
    },
    // $slots is not reactive, we need to update this manually
    checkSlots() {
      this.hasList = !!this.$scopedSlots.list, this.hasContent = !!this.$scopedSlots.default;
    },
    // browserStorage is not reactive, we need to update this manually
    restorePaneConfig() {
      const e = parseInt(n.getItem(this.paneConfigID), 10);
      if (!isNaN(e) && e !== this.listPaneSize)
        return console.debug("AppContent pane config", e), this.listPaneSize = e, e;
    },
    /**
     * The user clicked the back arrow from the details view
     */
    hideDetails() {
      this.$emit("update:showDetails", !1);
    }
  }
};
var C = function() {
  var t = this, i = t._self._c;
  return i("main", { staticClass: "app-content no-snapper", class: { "app-content--has-list": t.hasList }, attrs: { id: "app-content-vue" } }, [t.pageHeading ? i("h1", { staticClass: "hidden-visually" }, [t._v(" " + t._s(t.pageHeading) + " ")]) : t._e(), t.hasList ? [t.isMobile || t.layout === "no-split" ? i("div", { staticClass: "app-content-wrapper app-content-wrapper--no-split", class: {
    "app-content-wrapper--show-details": t.showDetails,
    "app-content-wrapper--show-list": !t.showDetails,
    "app-content-wrapper--mobile": t.isMobile
  } }, [t.showDetails ? i("NcAppDetailsToggle", { nativeOn: { click: function(s) {
    return s.stopPropagation(), s.preventDefault(), t.hideDetails.apply(null, arguments);
  } } }) : t._e(), t.showDetails ? t._t("default") : t._t("list")], 2) : t.layout === "vertical-split" || t.layout === "horizontal-split" ? i("div", { staticClass: "app-content-wrapper" }, [i("Splitpanes", { staticClass: "default-theme", class: {
    "splitpanes--horizontal": t.layout === "horizontal-split",
    "splitpanes--vertical": t.layout === "vertical-split"
  }, attrs: { horizontal: t.layout === "horizontal-split" }, on: { resized: t.handlePaneResize } }, [i("Pane", { staticClass: "splitpanes__pane-list", attrs: { size: t.listPaneSize || t.paneDefaults.list.size, "min-size": t.paneDefaults.list.min, "max-size": t.paneDefaults.list.max } }, [t._t("list")], 2), i("Pane", { staticClass: "splitpanes__pane-details", attrs: { size: t.detailsPaneSize, "min-size": t.paneDefaults.details.min, "max-size": t.paneDefaults.details.max } }, [t._t("default")], 2)], 1)], 1) : t._e()] : t._e(), t.hasList ? t._e() : t._t("default")], 2);
}, D = [], N = /* @__PURE__ */ o(
  b,
  C,
  D,
  !1,
  null,
  "a284c47e",
  null,
  null
);
const H = N.exports;
export {
  H as N
};
